var _path, _path2, _path3, _path4;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Winner2 = function Winner2(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsxs("g", {
      fill: color,
      children: [_path || (_path = /*#__PURE__*/_jsx("path", {
        d: "M17 12a6 6 0 1 1 6-6 6.013 6.013 0 0 1-6 6Zm0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM16 33h2v14h-2V33Z"
      })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
        d: "M23 48H11V21.95l-8.975-8.975a3.5 3.5 0 0 1 4.95-4.95L12.95 14H30.5a3.5 3.5 0 1 1 0 7H23v27Zm-10-2h8V19h9.5a1.5 1.5 0 0 0 0-3H12.125L5.563 9.438a1.503 1.503 0 0 0-2.125 2.125L13 21.125V46Z"
      })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
        d: "M30 14.226V2.014L33.038.589a6.213 6.213 0 0 1 5.637.225l1 .575a4.775 4.775 0 0 0 3.925.362L48 .19v12.125l-3.75 1.312a6.802 6.802 0 0 1-5.575-.512l-1-.575a4.186 4.186 0 0 0-3.787-.15L30 14.226Zm5.638-4.225a6.124 6.124 0 0 1 3.037.8l1 .575a4.788 4.788 0 0 0 3.925.363l2.4-.85V3.014l-1.75.612a6.8 6.8 0 0 1-5.575-.512l-1-.575a4.187 4.187 0 0 0-3.787-.15l-1.888.9v7.787l1.038-.487a6.135 6.135 0 0 1 2.6-.588ZM30 19.95h2V26h-2v-6.05Z"
      })), _path4 || (_path4 = /*#__PURE__*/_jsx("path", {
        d: "M30 12.648h2v2.403h-2v-2.403Z"
      }))]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        children: /*#__PURE__*/_jsx("path", {
          fill: color,
          d: "M0 0h48v48H0z"
        })
      })
    })]
  });
};
export default Winner2;